import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../store/actions'
import Gallery from '../../components/gallery'
import DefaultLayout from '../../layouts/default'
import Pagination from '../../components/pagination'
import Loading from '../../components/loading'

function mapStateToProps(state) {
  return { posts: state.posts.data, categories: state.categories, numPages: parseInt(state.posts.numPages, 10) };
}

const mapDispatchToProps = (dispatch) => {
  const { fetchPosts, fetchCategories } = actions;
  return {
    fetchPosts: bindActionCreators(fetchPosts, dispatch),
    fetchCategories: bindActionCreators(fetchCategories, dispatch)
  }
}

class OurWork extends Component {
  constructor() {
    super();

    this.state = {
      pageNumber: 1
    }
  }

  componentWillMount() {
    this.fetchPosts(this.props);
  }

  fetchPosts(props, category) {
    let _props = props || this.props;
    let _category = category || '2'

    _props.fetchPosts({
      'per_page': '28',
      'categories': _category,
      'page': this.state.pageNumber,
      'orderby': 'title',
      '_embed': 'true'
    }, () => {
      this.setState({
        isLoading: false
      })
    })

    _props.fetchCategories({
        'parent': '14'
    }, () => {

    })
  }

  nextPage() {
    this.setState({
      pageNumber: this.state.pageNumber + 1
    }, () => {
      this.fetchPosts();
    });
  }

  prevPage() {
    this.setState({
      pageNumber: this.state.pageNumber - 1
    }, () => {
      this.fetchPosts()
    });
  }

  render() {
    const posts = this.props.posts

    if (this.state.isLoading || !posts) { return <Loading /> }

    return (
      <DefaultLayout pagetitle={ this.props.pagetitle }>
        <div className="container container--grid">
          <div className="row">

            <Pagination
                  onNext={ this.nextPage.bind(this) }
                  onPrev={ this.prevPage.bind(this) }
                  page={ this.state.pageNumber }
                  pageCount={ this.props.numPages }
                  />
            <Gallery posts={ posts } />
            <Pagination
                  onNext={ this.nextPage.bind(this) }
                  onPrev={ this.prevPage.bind(this) }
                  page={ this.state.pageNumber }
                  pageCount={ this.props.numPages }
                  />
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(OurWork);



// WEBPACK FOOTER //
// ./src/routes/our-work/index.js